import RichText from "@/components/RichText";
import { CoverImage } from "../components/Primitives";
import { BODY_DARK, CONTAINER, DARK_BG, EYEBROW_DARK, OVERLAY_VERTICAL, RULE_DARK } from "../tokens";

// Bande sombre « Un savoir-faire construit au fil de plus de 40 années » :
// photo des bobines en fond (opacité .55) + dégradé vertical, texte à
// gauche, max-width 720px.
export default function SavoirBandSection({ props = {} }) {
  return (
    <section className="relative min-h-[400px] flex items-center overflow-hidden" style={DARK_BG}>
      <CoverImage src={props.image_url} alt={props.alt} opacity={0.55} />
      <div className="absolute inset-0" style={{ background: OVERLAY_VERTICAL }} aria-hidden="true" />
      <div className={`${CONTAINER} relative`}>
      <div className="px-5 md:px-11 py-[72px] max-w-[720px]">
        <RichText as="div" className={EYEBROW_DARK} html={props.eyebrow} />
        <RichText
          as="h2"
          className="font-display font-light text-[clamp(28px,3.6vw,44px)] leading-[1.15] text-cream mt-5 [text-wrap:balance]"
          html={props.heading}
        />
        <span className={`${RULE_DARK} mt-7 mb-5`} aria-hidden="true" />
        <RichText as="div" preserveParagraphs className={`${BODY_DARK} leading-[1.8]`} html={props.body} />
      </div>
      </div>
    </section>
  );
}
